<div class="form-group">
  <div class="d-inline">
    <label class="d-flex justify-content-between">
      {{expression.criteria.field!.title + ' ' + expression.criteria.operation!.operation}}
      <i class="icomoon icomoon-exit align-self-center" *ngIf="!disableDelete" (click)="onDelete.emit(expression)"></i>
    </label>
  </div>
  <input class="form-control" type="text" [(ngModel)]="expression.criteria.value" [textMask]="textMask">
</div>
